/// <amd-module name="CodeCoverage/ViewCommon/Constants" />

export const enum PathConstants {
    RootPath = "/",
    PathSeparator = "/",
    AltPathSeparator = "\\"
}

export const enum PerfScenarios {
    Area = "Pipelines",

    /**
     * This should match scenario name c_coverageCiTabPerfScenario in RunView.tsx
     */
    CodeCoverageCiTab = "Pipelines.CodeCoverage",

    FileCoverageDetails = "Pipelines.CodeCoverage.FileCoverageDetails",

    CodeCoverageAllTabFiltering = "Pipelines.CodeCoverage.AllTabFiltering"
}

export const enum TelemetryEvents {
    Area = "CodeCoverageCi",

    // Events
    CodeCoverageCiTabClicked = "CodeCoverageCiTabClicked",
    CodeCoverageFileDetailsViewed = "CodeCoverageFileDetailsViewed",
    CodeCoverageFetchSourceUrl = "CodeCoverageFetchSourceUrl",
    CodeCoverageCiAllTabClicked = "CodeCoverageCiAllTabClicked",
    CodeCoverageCiChangedTabClicked = "CodeCoverageCiChangedTabClicked"
}
